import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    storage = window.localStorage;
    sessionStorage = window.sessionStorage;
    constructor() {}

    token: BehaviorSubject<string> = new BehaviorSubject<string>(
        this.getToken()
    );
    token$ = this.token.asObservable().pipe(
        map((token) => {
            if (token && token !== `null`) {
                return true;
            } else {
                return false;
            }
        })
    );

    getRole() {
        return this.storage.getItem('role');
    }

    setRole(role) {
        return this.storage.setItem('role', role);
    }

    getTransferType() {
      return this.sessionStorage.getItem('transferType');
    }

    setTransferType(transferType) {
      return this.sessionStorage.setItem('transferType', transferType);
    }

    getToken() {
        return this.storage.getItem('token');
    }

    setToken(token) {
        return this.storage.setItem('token', token);
    }

    setTaxNumber(taxNumber) {
        this.storage.setItem('taxNumber', taxNumber);
    }

    getTaxNumber() {
        return this.storage.getItem('taxNumber');
    }

    setDateOfBirth(dateOfBirth) {
        this.storage.setItem('dateOfBirth', dateOfBirth);
    }

    getDateOfBirth() {
        return this.storage.getItem('dateOfBirth');
    }

    getRepresentativeAfm() {
        return this.storage.getItem('representativeAfm');
    }

    getRepresentativeAfm2() {
        return this.storage.getItem('representativeAfm2');
    }

    getRepresentativeEmail() {
        return this.storage.getItem('representativeEmail');
    }

    setUser(user) {
        this.storage.setItem('user', user);
    }

    getUser() {
        return this.storage.getItem('user');
    }

    clearStorage() {
        this.setRole(null);
        this.setToken(null);
        this.setTaxNumber(null);
        // this.storage.clear();
    }

    setMOCKTaxnumber(taxNumber) {
        this.storage.setItem('mockTaxnumber', taxNumber);
    }

    getMOCKTaxnumber() {
        return this.storage.getItem('mockTaxnumber');
    }
}
